import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Checklist() {
  const items = ['Choose a company that comes out to inspect the bathroom and take proper measurements', 'Ask whether installers are experienced glass professionals', 'Finalize the quote after exact measurements and product selections', 'Confirm the company can custom cut glass and hardware to fit the opening', 'Ask about glass options, hardware finishes and installation details', 'Ask what caulk is used; a clean, mildew-resistant, non-shrinking caulk is preferred', 'Avoid companies that rely on excess caulk to hide gaps', 'Ask about the installation guarantee before work begins'];
  return <section className="py-20 bg-white" data-id="element-1374" data-mp="3qw6r8u03h0re">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1375" data-mp="3qv52jmq5ofr7">
        <div className="max-w-3xl mx-auto text-center mb-16 anim-on-scroll" data-id="element-1376" data-mp="336lvfaiue90p">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1377" data-mp="2y92hyctyy09t">
            What to Look for Before Hiring a Shower Door Installer
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1378" data-mp="2r0453c0qf0ac">
            Use this scannable checklist to vet any shower glass installer
            before you commit.
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-gray-50 rounded-lg p-8 md:p-12 border border-gray-100 mb-12" data-id="element-1379" data-mp="2zv0mgrulvj9a">
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-1380" data-mp="34vfy9ez8oip5">
            {items.map((item, i) => <div key={i} className="flex items-start gap-4 scroll-fade-up" style={{
            animationDelay: `${i * 0.05}s`
          }} data-id="element-1381" data-mp="285fejudq8sep" data-mpi={i}>
                <CheckCircle2 className="w-6 h-6 text-primary shrink-0 mt-0.5" data-id="element-1382" data-mp="2m2kh3ke8f957" />
                <span className="text-gray-700 font-medium leading-relaxed" data-id="element-1383" data-mp="2m0hhq9r6w3nt">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1384" data-mp="1eppisc9vrjr">
          <a href="#quote" className="inline-flex items-center justify-center bg-navy hover:bg-navy-800 text-white font-semibold py-4 px-8 rounded-lg transition-colors" data-id="element-1385" data-mp="37t2bj48rtv7v">
            Schedule an In-Home Measurement
          </a>
        </div>
      </div>
    </section>;
}